<div class="contact-container" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <app-contact-form></app-contact-form>
</div>
